import axios from "axios";
import { articlesSlice, callTypes } from "./articlesSlice";

const API_URL = process.env.REACT_APP_API_URL;
const { actions } = articlesSlice;

export const fetchArticles = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return axios
    .get(API_URL + "articles/all", {
      params: { _limit: -1, _sort: "published_at:DESC" },
    })
    .then((response) => {
      dispatch(actions.articlesFetched({ articlesList: response.data }));
    })
    .catch((err) => {
      dispatch(actions.catchError({ error: err, callType: callTypes.list }));
    });
};

export const fetchArticle = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.get }));

  return axios
    .get(API_URL + `articles/${id}`)
    .then((response) => {
      dispatch(actions.articleFetched({ articleGet: response.data.article }));
    })
    .catch((err) =>
      dispatch(actions.catchError({ error: err, callType: callTypes.get }))
    );
};

export const fetchCategories = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));

  return axios
    .get(API_URL + "categories")
    .then((response) => {
      dispatch(actions.categoriesFetched({ categoriesList: response.data }));
    })
    .catch((err) => {
      dispatch(actions.catchError({ error: err, callType: callTypes.list }));
    });
};

export const createPoll = (poll) => (dispatch) => {
  return dispatch(actions.articlePollCreated({ poll: poll }));
};

export const postArticle = (article) => (dispatch) => {
  dispatch(
    actions.startCall({
      callType: callTypes.createArticle,
    })
  );
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };

  return axios
    .post(API_URL + "articles", article, config)
    .then((response) => {
      dispatch(
        actions.articleCreated({
          articleCreated: response.data,
        })
      );
    })
    .catch((err) => {
      dispatch(
        actions.catchError({
          error: err,
          callType: callTypes.createArticle,
        })
      );
    });
};

export const updateArticle = (article, id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.updateArticle }));
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };

  return axios
    .put(API_URL + `articles/${id}`, article, config)
    .then((response) => {
      return dispatch(
        actions.articleUpdated({ articleUpdated: response.data })
      );
    })
    .catch((err) => {
      return dispatch(
        actions.catchError({ error: err, callType: callTypes.updateArticle })
      );
    });
};

export const articleCleanState = () => (dispatch) => {
  dispatch(actions.articleListCleanState());
};

export const articleEditCleanState = () => (dispatch) => {
  dispatch(actions.articleEditCleanState());
};

export const articleCreatedCleanState = () => (dispatch) => {
  dispatch(actions.articleCreatedCleanState());
};

export const articlesHide = (articleReport) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.hide }));
  const body = {
    reason: articleReport.reasons,
    comment: articleReport.comments,
    send_pn: articleReport.notifications.includes("Send push"),
    send_email: articleReport.notifications.includes("Send email"),
  };
  return axios
    .put(API_URL + `articles/${articleReport.id}/hide`, body)
    .then((response) => {
      dispatch(actions.articleHided({ articleHided: response.data }));
    })
    .catch((err) =>
      dispatch(actions.catchError({ error: err, callType: callTypes.hide }))
    );
};

export const articleDelete = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.delete }));

  return axios
    .delete(API_URL + `articles/${id}`)
    .then((response) => {
      dispatch(actions.articleDelete({ articleDeleted: response.data }));
    })
    .catch((err) => {
      dispatch(actions.catchError({ error: err, callType: callTypes.delete }));
    });
};
